import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { auth } from './services/firebase'
import { loadUserDoc } from './services/auth'
import { registerForPushNotifications, onForegroundMessage } from './services/notifications'
import * as Sentry from "@sentry/vue"

Vue.config.productionTip = false

// Initialize Sentry early to catch errors during startup and authentication
Sentry.init({
  Vue,
  dsn: "https://ca53643d4f5bdf8813348091efefb857@o4511446131212288.ingest.us.sentry.io/4511454666883072",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
})

let app
let unsubscribeForegroundMessage = null

// Firebase auth state listener
auth.onAuthStateChanged(async user => {
  // Initialize Vue app if not already done
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }

  if (user) {
    // User is authenticated
    store.dispatch('setAuthState', 'authenticated')

    // Load user document from Firestore
    try {
      await loadUserDoc(user.uid)
    } catch (error) {
      console.error('Error loading user document:', error)
    }

    // Register for push notifications (non-blocking)
    registerForPushNotifications(user.uid).catch(err =>
        console.error('FCM registration failed:', err)
    )

    // Unsubscribe any existing foreground message listener before adding a new one
    // onAuthStateChanged can fire multiple times (token refresh etc.), which would
    // otherwise stack up duplicate listeners and cause duplicate notifications
    if (unsubscribeForegroundMessage) {
      unsubscribeForegroundMessage()
      unsubscribeForegroundMessage = null
    }

    // Handle foreground messages with an in-app notification.
    // Read title/body from payload.notification first (standard messages),
    // then fall back to payload.data (data-only messages from our backend).
    onForegroundMessage((payload) => {
      const title = payload.notification?.title || payload.data?.title
      const body = payload.notification?.body || payload.data?.body
      store.dispatch('showToast', { title, body })
    }).then(unsub => {
      unsubscribeForegroundMessage = unsub
    })
  } else {
    // User is not authenticated
    store.dispatch('setAuthState', 'unauthenticated')
    store.dispatch('setUserDoc', null)
  }
})